/* eslint-disable no-restricted-globals */
export default () => {
  self.addEventListener("message", (event) => {
    if (!event) return;
    const {
      userCips,
      cips,
      backwashes,
      cleaningEffectiness,
      fouling,
      predictionandRecommendData,
      predictionDataRaw,
      optimization_target,
      others,
      totalbenefitWindow,
      annualBenefitsWindow,
    } = event.data.exportData;
    const { exportWorkerTransaltionString } = event.data.translations;
    const foulingType = event.data.foulingType;

    const getLanguageCode = {
      USD: {
        code: "en-US",
        currency: "USD",
        symbol: "$",
      },
      Yuan: {
        code: "zh-CN",
        currency: "CNY",
        symbol: "元",
      },
      Euro: {
        code: "EUR",
        currency: "EUR",
        symbol: "€",
      },
    };

    const predictTypeFormatter = (type) => {
      if (type) {
        if (type === "shutdown") {
          return "Shutdown";
        } else if (type === "cip" || type === "ceb") {
          return type.toUpperCase();
        }
        return type;
      }
      return "-";
    };

    const getOptimizationMessage = (optimization_target) => {
      const messages = {
        "Minimize Total Cost": "Overall Financial Benefits",
        "Maximize Production Volume": "Water Production Increase",
        "Minimize Energy Cost": "Energy Cost Savings",
      };
      return messages[optimization_target] || "";
    };

    const formattedWaterProductionIncrease = (value, percentValue) => {
      if (value === undefined || value === null) return "-";
      let formatted = value;
      if (typeof value === "number") {
        formatted = value.toLocaleString();
      }
      if (percentValue !== undefined && percentValue !== null) {
        return `${formatted} (${percentValue.toFixed(2)}%)`;
      }
      return formatted;
    };

    const formattedEnergyCostSavings = (value, percentValue) => {
      if (value === undefined || value === null) return "-";
      let formatted = value;
      if (typeof value === "number") {
        formatted = value.toLocaleString();
      }
      if (percentValue !== undefined && percentValue !== null) {
        return `${formatted} (${percentValue.toFixed(2)}%)`;
      }
      return formatted;
    };

    const getOptimizationResult = (optimization_target, data) => {
      if (!data) return "-";
      switch (optimization_target) {
        case "Minimize Total Cost":
          return formattedCurrencyValue(data.total_financial_benefits);
        case "Maximize Production Volume":
          return formattedWaterProductionIncrease(
            data.increased_production,
            data.increased_production_percent
          );
        case "Minimize Energy Cost":
          return formattedEnergyCostSavings(
            data.energy_saving_dollars,
            data.energy_saving_percent
          );
        default:
          return "-";
      }
    };

    const averageFormatter = (avgField, sdField) => {
      if (avgField || sdField) {
        const avg = parseFloat(avgField);
        const sd = parseFloat(sdField);
        if (avg || sd) {
          return `${avg.toFixed(2)} (± ${sd.toFixed(2)})`;
        }
      }
      return "-";
    };
    const averageEffectivenessFormatter = (avgField, sdField) => {
      if (avgField || sdField) {
        const avg = parseFloat(avgField);
        const sd = parseFloat(sdField);
        if (avg || sd) {
          let result = `${avg.toFixed(2)} (± ${sd.toFixed(2)})`;
          if (avg > 100) {
            result += " ᵃ";
          } else if (avg < 0) {
            result += " ᵇ";
          }
          return result;
        }
      }
      return "-";
    };

    const dateFormatter = (date) => {
      if (date) {
        date = new Date(date);

        if (isNaN(date.getTime())) {
          return "Invalid Date";
        }
        const formattedDay = date.getDate().toString().padStart(2, "0");
        const formattedMonth = (date.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const formattedYear = date.getFullYear();

        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      } else return "-";
    };

    const cleaningFormatter = (params) => {
      if (params) {
        return params.toFixed(2);
      }
      return `-`;
    };
    const cleaningEfficitivenessFormatter = (params) => {
      if (isNaN(params)) {
        return "*";
      } else if (params < 0) {
        return "< 0% ᵇ";
      } else if (params > 100) {
        return "> 100% ᵃ";
      } else {
        return params.toFixed(2);
      }
    };
    const formattedCurrencyValue = (value) => {
      let formattedValue = value;
      const currency = others[0].currency;
      const languageCurrency = getLanguageCode[currency].currency;
      const currencySymbol = getLanguageCode[currency].symbol;
      const currencyCode = getLanguageCode[currency].code;

      if (value) {
        // value = Math.floor(value);
        formattedValue = value.toLocaleString(currencyCode, {
          style: "currency",
          currency: languageCurrency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      if (currencyCode === "zh-CN" && formattedValue)
        formattedValue = formattedValue.replace("¥", "元");
      return formattedValue === 0
        ? `${currencySymbol}${formattedValue}`
        : formattedValue;
    };

    const formatDecimal = (value) => {
      value = parseFloat(value);
      return value > 0 ? value.toFixed(2) : value.toFixed(2);
    };

    const cipSheetData = cips?.map((data, index) => {
      return {
        ...data,
        index: index + 1,
        start_date: dateFormatter(data.cleaning_start_time),
        end_date: dateFormatter(data.cleaning_end_time),
        next_cec_start_date: dateFormatter(data.next_cec_start_date),
        type: predictTypeFormatter(data.cleaning_type),
        avg_duration_between_backwash_mins: averageFormatter(
          data.avg_duration_between_backwash_mins,
          data.sd_duration_between_backwash_mins
        ),

        avg_backwash_duration_secs: averageFormatter(
          data.avg_backwash_duration_secs,
          data.sd_backwash_duration_secs
        ),

        avg_duration_between_CEB_mins: averageFormatter(
          data.avg_duration_between_CEB_mins,
          data.sd_duration_between_CEB_mins
        ),

        avg_CEB_duration_secs: averageFormatter(
          data.avg_CEB_duration_secs,
          data.sd_CEB_duration_secs
        ),

        is_tool_identified: data.is_tool_identified
          ? exportWorkerTransaltionString.calculation
          : exportWorkerTransaltionString.user,
        acidPh: data.acid_cip_ph,
        acidTemperature: data.acid_cip_temp,
        acidDuration: data.acid_cip_duration,
        acidUsed: data.acid_used_per_cip,
        alkaliPh: data.alkali_cip_ph,
        alkaliTemperature: data.alkali_cip_temp,
        alkaliDuration: data.alkali_cip_duration,
        alkaliUsed: data.alkali_used_per_cip,
        solutionPh: data.cip_solution_ph,
        solutionTemperature: data.cip_solution_temp,
        solutionDuration: data.cip_solution_duration,
        solutionUsed: data.additional_chemical_per_cip,
        addInfo: data.add_info,
      };
    });
    const backwashSheetData = backwashes?.map((data, index) => {
      return {
        ...data,
        index: index + 1,
        start_date: dateFormatter(data.cleaning_start_time),
        end_date: dateFormatter(data.cleaning_end_time),
        next_cec_start_date: dateFormatter(data.next_cec_start_date),
        type: predictTypeFormatter(data.cleaning_type),
        avg_duration_between_backwash_mins: averageFormatter(
          data.avg_duration_between_backwash_mins,
          data.sd_duration_between_backwash_mins
        ),

        avg_backwash_duration_secs: averageFormatter(
          data.avg_backwash_duration_secs,
          data.sd_backwash_duration_secs
        ),

        avg_duration_between_CEB_mins: averageFormatter(
          data.avg_duration_between_CEB_mins,
          data.sd_duration_between_CEB_mins
        ),

        avg_CEB_duration_secs: averageFormatter(
          data.avg_CEB_duration_secs,
          data.sd_CEB_duration_secs
        ),

        is_tool_identified: data.is_tool_identified
          ? exportWorkerTransaltionString.calculation
          : exportWorkerTransaltionString.user,
        acidPh: data.acid_cip_ph,
        acidTemperature: data.acid_cip_temp,
        acidDuration: data.acid_cip_duration,
        acidUsed: data.acid_used_per_cip,
        alkaliPh: data.alkali_cip_ph,
        alkaliTemperature: data.alkali_cip_temp,
        alkaliDuration: data.alkali_cip_duration,
        alkaliUsed: data.alkali_used_per_cip,
        solutionPh: data.cip_solution_ph,
        solutionTemperature: data.cip_solution_temp,
        solutionDuration: data.cip_solution_duration,
        solutionUsed: data.additional_chemical_per_cip,
        addInfo: data.add_info,
      };
    });

    const cleaningEffectinessSheetData = cleaningEffectiness?.map(
      (data, index) => {
        return {
          ...data,
          index: index + 1,
          start_date: dateFormatter(data.cleaning_start_time),
          end_date: dateFormatter(data.cleaning_end_time),
          next_cec_start_date: dateFormatter(data.next_cec_start_date),
          type: predictTypeFormatter(data.cleaning_type),
          effectiveness: cleaningEfficitivenessFormatter(data.effectiveness),
          efficiency: cleaningFormatter(data.slope_new),
          avg_bw_cleaning_effectiveness: averageEffectivenessFormatter(
            data.avg_backwash_effectiveness,
            data.sd_backwash_effectiveness
          ),

          avg_bw_cleaning_efficiency: averageFormatter(
            data.avg_backwash_slope,
            data.sd_backwash_slope
          ),

          avg_ceb_effectiveness: averageEffectivenessFormatter(
            data.avg_ceb_effectiveness,
            data.sd_ceb_effectiveness
          ),

          avg_ceb_slope: averageFormatter(
            data.avg_ceb_slope,
            data.sd_ceb_slope
          ),
        };
      }
    );

    // const foulingSheetData = fouling?.map((data, index) => {
    //   return {
    //     ...data,
    //     index: index + 1,
    //     type: typeFormatter(data.data[0].type, "C"),
    //     start_date: dateFormatter(data.start_date),
    //     end_date: dateFormatter(data.end_date),
    //     primary_reason: reasonFormatter(data?.data, true),
    //     secondary_reason: reasonFormatter(data?.data, false),
    //   };
    // });

    const otherSheetData = others;
    const predicitionSheetData = predictionandRecommendData?.map(
      (data, index) => {
        const predictedItem = data.predictedItem;
        const recommendedItem = data.recommendedItem;
        return {
          predictIndex: predictedItem.start_date ? index + 1 : "-",
          predictType: predictTypeFormatter(predictedItem.type),
          predictStart_date: dateFormatter(predictedItem.start_date),
          predictedNextStartDate: dateFormatter(predictedItem.next_start_date),
          predictedAverageDurationBetweenBackwash: cleaningFormatter(
            predictedItem.predicted_average_duration_between_backwash
          ),
          predictedAverageBackwashDurationSecs: cleaningFormatter(
            predictedItem.predicted_average_backwash_duration_secs
          ),
          predictedAverageDurationBetweenCeb: cleaningFormatter(
            predictedItem.predicted_average_duration_between_ceb
          ),
          predictedAverageCebDurationSecs: cleaningFormatter(
            predictedItem.predicted_average_ceb_duration_secs
          ),
          recommendIndex: recommendedItem.start_date ? index + 1 : "",
          recommendType: predictTypeFormatter(recommendedItem.type),
          recommendStart_date: dateFormatter(recommendedItem.start_date),
          recommendedNextStartDate: dateFormatter(
            recommendedItem.next_start_date
          ),
          recommendedAverageDurationBetweenBackwash: cleaningFormatter(
            recommendedItem.recommend_average_duration_between_backwash
          ),
          recommendedAverageBackwashDurationSecs: cleaningFormatter(
            recommendedItem.recommend_average_backwash_duration_secs
          ),
          recommendedAverageDurationBetweenCeb: cleaningFormatter(
            recommendedItem.recommend_average_duration_between_ceb
          ),
          recommendedAverageCebDurationSecs: cleaningFormatter(
            recommendedItem.recommend_average_ceb_duration_secs
          ),
        };
      }
    );

    let benefitSheetDataMessage = "";
    let benefitSheetData = null;
    const totalFinancialBenefits = predictionDataRaw
      ? parseInt(predictionDataRaw["total_financial_benefits"])
      : 0;

    if (totalFinancialBenefits > 0) {
      benefitSheetDataMessage = `${getOptimizationMessage(
        optimization_target
      )} (${totalbenefitWindow}) : ${getOptimizationResult(
        optimization_target,
        predictionDataRaw
      )}`;
      benefitSheetData = [
        {
          financialEnergy: formatDecimal(
            predictionDataRaw?.energy_saving_percent
          ),
          financialEnergyCost: formattedCurrencyValue(
            predictionDataRaw?.energy_saving_dollars
          ),
          financialChemical: formatDecimal(
            predictionDataRaw?.chemical_saving_percent
          ),
          financialChemicalCost: formattedCurrencyValue(
            predictionDataRaw?.chemical_saving_dollars
          ),
          financialDownTime: formatDecimal(
            predictionDataRaw?.downtime_saving_percent
          ),
          financialDownTimeCost: formattedCurrencyValue(
            predictionDataRaw?.downtime_saving_dollars
          ),
          financialIncreasedProduction: formatDecimal(
            predictionDataRaw?.increased_production_percent
          ),
          financialIncreasedProductionCost: formattedCurrencyValue(
            predictionDataRaw?.increased_production_dollars
          ),
        },
      ];
    }

    let annualBenefitSheetDataMessage = "";
    let annualBenefitSheetData = null;
    const annualTotalFinancialBenefits = predictionDataRaw
      ? parseInt(predictionDataRaw["annual_total_financial_benefits"])
      : 0;

    if (
      predictionDataRaw?.forcast_window < 365 &&
      predictionDataRaw?.forcast_window > 182 &&
      annualTotalFinancialBenefits > 0
    ) {
      annualBenefitSheetDataMessage = `${getOptimizationMessage(
        optimization_target
      )}(${annualBenefitsWindow}) : ${getOptimizationResult(
        optimization_target,
        {
          ...predictionDataRaw,
          total_financial_benefits:
            predictionDataRaw.annual_total_financial_benefits,
          increased_production: predictionDataRaw.annual_increased_production,
          increased_production_percent:
            predictionDataRaw.annual_increased_production_percent,
          energy_saving_dollars: predictionDataRaw.annual_energy_saving_dollars,
          energy_saving_percent: predictionDataRaw.annual_energy_saving_percent,
        }
      )}`;

      annualBenefitSheetData = [
        {
          financialEnergy: formatDecimal(
            predictionDataRaw?.annual_energy_saving_percent
          ),
          financialEnergyCost: formattedCurrencyValue(
            predictionDataRaw?.annual_energy_saving_dollars
          ),
          financialChemical: formatDecimal(
            predictionDataRaw?.annual_chemical_saving_percent
          ),
          financialChemicalCost: formattedCurrencyValue(
            predictionDataRaw?.annual_chemical_saving_dollars
          ),
          financialDownTime: formatDecimal(
            predictionDataRaw?.annual_downtime_saving_percent
          ),
          financialDownTimeCost: formattedCurrencyValue(
            predictionDataRaw?.annual_downtime_saving_dollars
          ),
          financialIncreasedProduction: formatDecimal(
            predictionDataRaw?.annual_increased_production_percent
          ),
          financialIncreasedProductionCost: formattedCurrencyValue(
            predictionDataRaw?.annual_increased_production_dollars
          ),
        },
      ];
    }

    postMessage({
      predicitionSheetData,
      benefitSheetDataMessage,
      annualBenefitSheetDataMessage,
      benefitSheetData,
      annualBenefitSheetData,
      cipSheetData,
      backwashSheetData,
      cleaningEffectinessSheetData,
      // foulingSheetData,
      otherSheetData,
    });
  });
};
